const companyTypes = [
    'Startup',
    'Small Business',
    'Medium-sized Enterprise (SME)',
    'Large Corporation',
    'Multinational Corporation',
    'Public Company',
    'Private Company',
    'Nonprofit Organization',
    'Government Agency',
    'Educational Institution',
    'Not registered company'
]
export default companyTypes;
  
  

  
  